import { UserType } from "../types/UserType";

export const DefaultUser: UserType = {
    id: -1,
    name: "",
    email: "",
    password: "",
    profile_id: -1    
}